import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IWorkingCopyFileService = ( createDecorator('workingCopyFileService'));
export { IWorkingCopyFileService };
